export const TYPES = [
    'bag',
    'package'
];
export const BAG_TYPE = TYPES[0];
export const PACKAGE_TYPE = TYPES[1];
